import { PayloadAction } from "@reduxjs/toolkit";
import { ServiceState } from "../../models/ServiceState";
import { GetServicePayload } from "../../payload/GetService/GetServicePayload";

const getServiceFetch = (state: ServiceState, action: PayloadAction<GetServicePayload>) => {
    state.isLoading = true;
}

export default getServiceFetch;